export const SPIDER_BASE_URL = `${import.meta.env.BUILD_API_BASE_URL}/spider`;
